import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Button, Card, InputNumber, SelectProps, Table, Tag} from "antd";
import Colors from "../../../styles/Colors";
import {BiArrowBack, BiPencil, BiPlus, BiRefresh, BiSave, BiSend, BiTrash} from "react-icons/bi";
import Historials from "../../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye, BsReceipt} from "react-icons/bs";
import PlantillaModal from "../../PlantillaModal";
import {format} from "date-fns";
import toast from "react-hot-toast";
import {GetComandaId} from "../../../dao/menudesign/comandes/GetComandaId";
import {NumberOutlined} from "@ant-design/icons";
import {User} from "../../../model/root/User";
import UsuarisList from "../components/UsuarisList";

const Comandes = () => {
    const titol: string = "Editar Comanda";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<any[]>([]);
    const [participants, setParticipants] = useState<any[]>([]);
    const [altres, setAltres] = useState<any[]>([]);
    const [elementSelected, setElementSelected] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);

    useEffect(() => {
        if(isLoggedIn){
            handleLoadingChange(true)
            checkDades();
        }

    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetComandaId(page, id+"");
        setDades(dades.plats);
        setParticipants(dades.participants);
        setAltres(dades.altres);

        const allKeys = dades.plats?.map((item: any) => item.id) || [];
        console.log(allKeys);
        setExpandedRowKeys(allKeys);
        console.log(JSON.stringify(dades));
        handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(id: number) {
        //await Deleteany(id, page);
        await checkDades();
    }

    function afegirElement(element: any) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function togleNouElement(element: any) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouElement(false);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: any[]) {
        if (elements?.length > 0) {
            const uniqueNonEmptyNames = Array.from(new Set(elements
                .map((element) => element.escola)
                .filter((name) => name !== '')));

            const ingredientNames = uniqueNonEmptyNames.map((name) => ({
                text: name,
                value: name,
            }));

            setNomFiltres(ingredientNames);
        }
    }

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            dataIndex: 'id',
            title: 'ID'
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            title: 'Nom Plat',
            render: (estat, ele) => (
                <Tag color={Colors.colors.color1}>{estat}</Tag>
            )
        },
        {
            key: 'dia_setmana',
            dataIndex: 'dia_setmana',
            title: 'Dia Setmana'
        },
        {
            key: 'data',
            dataIndex: 'data',
            title: 'Data'
        },
    ];

    const columnsAltres: ColumnsType<any> = [
        {
            key: 'id',
            dataIndex: 'id',
            title: 'ID'
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            title: 'Ingredient'
        },
        {
            key: 'cuina',
            dataIndex: 'cuina',
            title: 'Precisa Cuina?',
            render: (estat, ele) => (
                <Tag color={estat === "1" ? Colors.colors.color2 : Colors.colors.color5}>{estat === "1" ? "SÍ" : "NO"}</Tag>
            )
        },
        {
            key: 'accions', dataIndex: 'accions',
            title: 'Afegir',
            render: (estat, ele) => (
                <InputNumber style={{backgroundColor: Colors.colors.color6}}
                             defaultValue={0.0} min={0} step={0.1}  addonAfter={ele.mesura}/>
            )
        },
        {
            key: 'accions', dataIndex: 'accions',
            title: 'Afegit',
            render: (estat, ele) => (
                <InputNumber defaultValue={0.0} disabled={true}  step={0.1} addonBefore="+" addonAfter={ele.mesura}/>
            )
        },
    ];

    const columnsIngredients: ColumnsType<any> = [
        {
            key: 'id',
            dataIndex: 'id',
            title: 'ID'
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            title: 'Ingredient'
        },
        {
            key: 'cuina',
            dataIndex: 'cuina',
            title: 'Precisa Cuina?',
            render: (estat, ele) => (
                <Tag color={estat === "1" ? Colors.colors.color2 : Colors.colors.color5}>{estat === "1" ? "SÍ" : "NO"}</Tag>
            )
        },
        {
            key: 'accions', dataIndex: 'accions',
            title: 'Estimat',
            render: (estat, ele) => (
                <InputNumber disabled={true} defaultValue={ele.total} min={0} step={0.1}
                             addonAfter={ele.mesura}/>
            )
        },
        {
            key: 'accions', dataIndex: 'accions',
            title: 'Afegit',
            render: (estat, ele) => (
                <InputNumber style={{backgroundColor: Colors.colors.color6}}
                             defaultValue={0.0}  step={0.1} addonBefore="+" addonAfter={ele.mesura}/>
            )
        },
        {
            key: 'accions', dataIndex: 'accions',
            title: 'Total',
            render: (estat, ele) => (
                <InputNumber disabled={true} defaultValue={0.0}  step={0.1} addonBefore="+" addonAfter={ele.mesura}/>
            )
        },
    ];

    const columnsParticpants: ColumnsType<any> = [
        {
            key: 'dia',
            dataIndex: 'dia',
            title: 'Dia'
        },
        {
            key: 'escola',
            dataIndex: 'escola',
            title: 'Escola'
        },
        {
            key: 'qInfantil',
            dataIndex: 'qInfantil',
            title: 'Alumnes Infantil',
            render: (estat, ele) => (
                <Tag color={Colors.colors.color2}>{estat}</Tag>
            )
        },
        {
            key: 'qPrimaria',
            dataIndex: 'qPrimaria',
            title: 'Alumnes Primaria',
            render: (estat, ele) => (
                <Tag color={Colors.colors.color3}>{estat}</Tag>
            )
        },
        {
            key: 'qAdult',
            dataIndex: 'qAdult',
            title: 'Adults',
            render: (estat, ele) => (
                <Tag color={Colors.colors.color4}>{estat}</Tag>
            )
        },
        {
            key: 'Totals',
            dataIndex: 'Totals',
            title: 'Totals',
            render: (estat, ele) => (
                <Tag color={Colors.colors.color5}>{ele.qInfantil + ele.qPrimaria + ele.qAdult}</Tag>
            )
        }
    ];

    const tableProps: TableProps<any> = {
        loading
    };

    const onChange: TableProps<any>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };


    function handleBack() {
        navigate(`/menudesign/propostes`);
    }

    function handleGuardar() {
        alert("TODO");
    }

    const expandedRowRender2 = (ele: any) => {

        return (
            <>
                <br/>
                <Table style={{paddingLeft: "10%"}}
                    {...tableProps}
                    pagination={false}
                    onChange={onChange}
                    size={"small"}
                    columns={columnsIngredients}
                    dataSource={ele.ingredients}
                />
                <br/>
            </>
    )
        ;
    };


    if (isLoggedIn) {
        return (
            <div>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"} style={{alignItems: "center", display: "flex"}}>
                            <Button title={"Enrere"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                handleBack()}><BiArrowBack/></Button>
                            <Button title={"Guardar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                handleGuardar()}><BiSave/></Button>
                            <Button title={"Validar"} style={{backgroundColor: Colors.colors.color5}} onClick={() =>
                                handleGuardar()}><BiSend/></Button>
                        </div>
                        <h4 className={"titol"}>PARTICIPANTS</h4>
                        {visible && (
                            <>
                                <Table
                                    {...tableProps}
                                    pagination={false}
                                    onChange={onChange}
                                    columns={columnsParticpants}
                                    dataSource={participants}
                                />
                                <br/>
                                <h4 className={"titol"}>COMANDA</h4>
                                <hr/>
                                <Table
                                    {...tableProps}
                                    pagination={false}
                                    onChange={onChange}
                                    columns={columns}
                                    expandable={{
                                        defaultExpandAllRows: true,
                                        expandedRowKeys: expandedRowKeys,
                                        expandedRowRender: (record) =>
                                            expandedRowRender2(record),
                                        rowExpandable: (record) => record.ingredients !== null,

                                    }}
                                    dataSource={coleccio}
                                />
                                <br/>
                                <h4 className={"titol"}>Altres ingredients</h4>
                                <hr/>
                                <Table
                                    {...tableProps}
                                    pagination={false}
                                    size={"small"}
                                    onChange={onChange}
                                    columns={columnsAltres}
                                    dataSource={altres}
                                />
                            </>
                        )}
                    </Card>
                    {nouElement && (
                        <PlantillaModal element={elementSelected} onClose={handleCloseModal} visible={nouElement}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Comandes;
